import React, { createContext, useContext, useState, ReactNode } from 'react';
import SessionExpiredModal from '../components/SessionExpiredModal';

interface SessionExpiredContextType {
  showSessionExpired: () => void;
}

const SessionExpiredContext = createContext<SessionExpiredContextType | undefined>(undefined);

export const useSessionExpired = () => {
  const context = useContext(SessionExpiredContext);
  if (!context) {
    throw new Error('useSessionExpired must be used within SessionExpiredProvider');
  }
  return context;
};

interface SessionExpiredProviderProps {
  children: ReactNode;
}

export const SessionExpiredProvider: React.FC<SessionExpiredProviderProps> = ({ children }) => {
  const [showModal, setShowModal] = useState(false);

  const showSessionExpired = () => {
    // CRÍTICO: Verificar si acabamos de hacer logout antes de mostrar el modal
    const logoutTimestamp = sessionStorage.getItem('logoutTimestamp');
    const justLoggedOut = logoutTimestamp && (Date.now() - parseInt(logoutTimestamp)) < 10000; // 10 segundos
    
    // NO mostrar el modal si acabamos de hacer logout
    if (justLoggedOut) {
      return;
    }
    
    // CRÍTICO: Verificar si estamos en la página de login
    if (window.location.pathname === '/login' || window.location.pathname === '/' || window.location.pathname.includes('login')) {
      return;
    }
    
    // CRÍTICO: Verificar si no hay usuario en localStorage (ya cerramos sesión)
    const user = localStorage.getItem('user');
    if (!user) {
      return;
    }
    
    setShowModal(true);
  };

  return (
    <SessionExpiredContext.Provider value={{ showSessionExpired }}>
      {children}
      <SessionExpiredModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
      />
    </SessionExpiredContext.Provider>
  );
};
